import { render, staticRenderFns } from "./Contextmenu.vue?vue&type=template&id=5054b9a8&scoped=true"
import script from "./Contextmenu.vue?vue&type=script&lang=js"
export * from "./Contextmenu.vue?vue&type=script&lang=js"
import style0 from "./Contextmenu.vue?vue&type=style&index=0&id=5054b9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054b9a8",
  null
  
)

export default component.exports